import { lazy } from "react";

const PrivateRoutes: any[] = [
  // USER DASHBOARD //
  {
    id: "userDashboard",
    name: "User Dashboard",
    path: "/dashboard/*",
    component: lazy(() => import("@/pages/user/dashboard")),
    type: "private",
    props: {},
  },
  // USER DASHBOARD //
];

export default PrivateRoutes;
